import React, { useContext, useState } from "react";
import { toast } from "react-toastify";
import { showSuccess, showError } from "../utils/toast";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Grid, Paper } from "@mui/material";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import AvatarUI from "../components/material-ui/AvatarUI";
import InputUI from "../components/material-ui/InputUI";
import CheckboxUI from "../components/material-ui/CheckboxUI";
import ButtonUI from "../components/material-ui/ButtonUI";
import { AuthContext } from "../context/Auth/AuthContext";
import { useRoleContext } from "../context/RolesContext";
import loginUserDev from "../api/loginDev";
import loginIllustration from "../images/data.png";
import illustrationBg from "../images/illustration_bg.png";
import main_bg from "../images/login_bg.png";
import "../styles/Login.css";

const loginSchema = yup.object().shape({
  email: yup.string().email().required("Email is required."),
  password: yup.string().min(6).max(16).required("Password is required."),
});

/*** Main component for showing the login form ***/
const LoginDev = () => {
  const [loading, setLoading] = useState(false);
  const { setRoles } = useRoleContext();

  const { dispatch } = useContext(AuthContext);
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(loginSchema),
  });

  const onLoginFormSubmit = async (loginFormData) => {
    setLoading(true);
    const loginResponse = await loginUserDev({
      email: loginFormData.email,
      password: loginFormData.password,
    });
    if (loginResponse?.token) {
      // Cookie for viewing the document directly
      document.cookie =
        "skip_login=true; domain=.consumerlaw.com; path=/; secure; SameSite=None";
      setLoading(false);
      setRoles(loginResponse.user.role_id);
      localStorage.setItem("role_id", loginResponse.user.role_id);
      dispatch({
        type: "LOGIN",
        payload: {
          token: loginResponse.token,
          id: loginResponse.user.id,
          user_id: loginResponse.user.user_id,
          firstName: loginResponse.user.first_name,
          lastName: loginResponse.user.last_name,
          phoneNumber: loginResponse.user.phonenumber,
          is_admin: loginResponse.user.is_admin,
          email_id: loginResponse.user.email,
        },
      });
      showSuccess("Successfully Logged In");
      navigate("/dashboard");
    }
    if (loginResponse?.message) {
      setLoading(false);
      toast.error(loginResponse?.message, {
        position: "top-center",
        autoClose: 5000,
        theme: "dark",
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    if (loginResponse?.errors?.email[0] || loginResponse?.errors?.password[0]) {
      setLoading(false);
      showError("Every field is required");
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmit(onLoginFormSubmit)();
    }
  };

  return (
    <Grid className="login" style={{ backgroundImage: `url(${main_bg})` }}>
      <div className="login-container">
        <div
          className="illustration_wrapper"
          style={{ backgroundImage: `url(${illustrationBg})` }}
        >
          <img src={loginIllustration} />
        </div>
        <div className="login_form_wrapper">
          <AvatarUI>
            <AccountCircleRoundedIcon />
          </AvatarUI>
          <h2>Hello Again!</h2>
          <form onSubmit={handleSubmit(onLoginFormSubmit)}>
          <InputUI
            name="email"
            label="Enter your Email ID"
            type="email"
            variant="outlined"
            fullWidth={true}
            required={true}
            cssStyles={{ margin: "15px 0px 0px" }}
            register={register}
            onKeyDown={handleKeyDown}
          />
          <span className="error-message">{errors["email"]?.message}</span>
          <InputUI
            name="password"
            label="Enter your Password"
            type="password"
            variant="outlined"
            fullWidth={true}
            required={true}
            cssStyles={{ margin: "15px 0px 0px" }}
            register={register}
            onKeyDown={handleKeyDown}
          />
          <span className="error-message">{errors["password"]?.message}</span>
          {/* <div className="login-remember-me">
            <CheckboxUI label="Remember Me" />
            <Link to="/forgot-password" className="go-to-password-reset-form">
              &nbsp;Forgot Password?
            </Link>
          </div> */}
          <div className="login_btn">
            <ButtonUI
              type="submit"
              loading={loading}
              variant="contained"
              buttonText="Login"
              style={{
                width: "150px",
                height: "35px",
                backgroundColor: "#1a6b7c",
                boxShadow: "none",
                border: "1px solid #1a6b7c",
                fontWeight: "500",
                borderRadius: "4px",
                letterSpacing: "0.07rem",
                marginTop: "20px",
              }}
              handleSubmit={handleSubmit}
              onFormSubmit={onLoginFormSubmit}
            />
          </div>
          </form>
          {/* <div className="login-new-user">
            New User?{" "}
            <Link to="/register" className="go-to-register-form">
              &nbsp;Register
            </Link>
          </div> */}
        </div>
      </div>
    </Grid>
  );
};

export default LoginDev;
